<div class="verification-container" >
    <div class="logo" style="margin-top: 20px;">
        <img class="logop" src="../../../assets/logo-n.png">    </div>
        <div class="success-animation">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        </div>
        <h2 class="verification-message" style="color: white;margin-bottom: 31%;
        margin-top: 10%;">Compte activé avec succès!</h2>
</div>
